// Matevara — theme-configurable hover mega menus.
// Each [data-fs-mega] panel binds to the header nav item whose text matches its
// data-fs-mega-trigger. Hover the item (or the panel) to open; grace-delay close;
// Esc closes. Desktop only — panels are display:none under 990px (CSS).
// Page scroll is locked while any panel is open.
(function () {
  'use strict';

  var docEl = document.documentElement;
  var openCount = 0;

  // Lock page scroll while a mega is open (compensate scrollbar width so the
  // header/content doesn't shift). Shared across panels via openCount.
  function lockScroll() {
    if (openCount > 0) return;
    var sbw = window.innerWidth - docEl.clientWidth;
    if (sbw > 0) docEl.style.paddingRight = sbw + 'px';
    docEl.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (openCount > 0) return;
    docEl.style.overflow = '';
    docEl.style.paddingRight = '';
  }

  // Anchor a fixed panel's top to the header's bottom edge (the #header-group
  // wrapper collapses to 0 height, so top:100% won't work). For 'normal'
  // (compact) panels, also anchor its left edge to the trigger.
  function syncPos(mega, trigger) {
    var header = document.querySelector('.header-wrapper, .header, [class*="header-wrapper"]');
    if (header) {
      var b = Math.round(header.getBoundingClientRect().bottom);
      if (b > 0) mega.style.setProperty('--fs-mega-top', b + 'px');
    }
    if (mega.classList.contains('fs-mega--normal') && trigger) {
      var tx = Math.round(trigger.getBoundingClientRect().left);
      // clamp so the panel never runs off-screen right
      var maxLeft = window.innerWidth - Math.min(mega.offsetWidth || 320, 520) - 16;
      if (tx > maxLeft) tx = Math.max(16, maxLeft);
      mega.style.setProperty('--fs-mega-left', tx + 'px');
    }
  }

  var closers = [];

  function bindPanel(mega) {
    var wanted = (mega.getAttribute('data-fs-mega-trigger') || '').trim().toLowerCase();
    if (!wanted) return;

    // Find the matching header nav trigger by exact text.
    var trigger = null;
    var links = document.querySelectorAll('#header-group .header__menu-item, #header-group .header__inline-menu a');
    for (var i = 0; i < links.length; i++) {
      var t = (links[i].textContent || '').trim().toLowerCase();
      if (t === wanted) { trigger = links[i]; break; }
    }
    if (!trigger) return;

    // Add a dropdown caret to the trigger so users know it opens a panel (once).
    if (!trigger.querySelector('.fs-mega-caret')) {
      var caret = document.createElement('span');
      caret.className = 'fs-mega-caret';
      caret.setAttribute('aria-hidden', 'true');
      caret.innerHTML = '<svg viewBox="0 0 8 5" width="8" height="5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l3 3 3-3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      trigger.appendChild(caret);
      trigger.classList.add('fs-has-mega');
    }

    // Hover zone = nearest list item (bigger target than the <a>).
    var zone = trigger.closest('li') || trigger;
    var closeTimer = null;
    var isOpen = false;

    function open() {
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return;
      clearTimeout(closeTimer);
      syncPos(mega, trigger);
      lockScroll();
      if (!isOpen) { isOpen = true; openCount++; }
      mega.classList.add('is-open');
      trigger.classList.add('fs-mega-open');
    }
    function doClose() {
      if (isOpen) { isOpen = false; openCount = Math.max(0, openCount - 1); }
      mega.classList.remove('is-open');
      trigger.classList.remove('fs-mega-open');
      unlockScroll();
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(doClose, 140);
    }

    zone.addEventListener('mouseenter', open);
    zone.addEventListener('mouseleave', scheduleClose);
    mega.addEventListener('mouseenter', open);
    mega.addEventListener('mouseleave', scheduleClose);
    zone.addEventListener('focusin', open);

    closers.push(doClose);
  }

  // ── Mobile: turn the matching drawer item into an Ella-style slide-in submenu.
  //    Tap the item's arrow → a child panel slides in from the right (a full
  //    drawer overlay) with a "← [parent]" back header + the cloned panel content
  //    (links + products for mega, links for normal). Matches Ella's native
  //    drawer submenu behaviour. ──
  function buildMobileSubmenus(panels) {
    var drawer = document.querySelector('#Drawer-Menu');
    if (!drawer) return;
    // Slide-in panels sit inside the drawer's visible inner box and fill it BELOW
    // the drawer header (so the close ✕ stays visible/tappable).
    var host = drawer.querySelector('.drawer__inner') || drawer;
    var dHeader = host.querySelector('.drawer__header');
    function syncHeaderOffset() {
      var h = dHeader ? Math.round(dHeader.getBoundingClientRect().height) : 0;
      host.style.setProperty('--fs-msub-top', h + 'px');
    }
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);

    for (var i = 0; i < panels.length; i++) {
      var mega = panels[i];
      var wanted = (mega.getAttribute('data-fs-mega-trigger') || '').trim().toLowerCase();
      if (!wanted) continue;

      // Matching drawer item link by text.
      var dLinks = drawer.querySelectorAll('a');
      var link = null;
      for (var j = 0; j < dLinks.length; j++) {
        if ((dLinks[j].textContent || '').trim().toLowerCase() === wanted) { link = dLinks[j]; break; }
      }
      if (!link) continue;
      var item = link.closest('.menu-drawer__list-item') || link.parentElement;
      if (!item || item.querySelector('.fs-msub-trigger')) continue; // already built

      var inner = mega.querySelector('.fs-mega__inner');
      if (!inner) continue;
      var label = link.textContent.trim();

      // Trigger row (replaces the plain link) — label + right arrow, Ella-style.
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'fs-msub-trigger';
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.innerHTML = '<span>' + label + '</span>' +
        '<span class="fs-msub-arrow" aria-hidden="true"><svg viewBox="0 0 14 10" width="14" height="10" fill="none"><path d="M9 1l4 4-4 4M13 5H1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      link.style.display = 'none';
      item.insertBefore(trigger, link.nextSibling);

      // Slide-in child panel (overlay inside the drawer). Two zones:
      //   • links  — scrollable (grows/shrinks)
      //   • products — pinned at the bottom, always in one fold
      var panel = document.createElement('div');
      panel.className = 'fs-msub-panel';

      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'fs-msub-back';
      back.innerHTML = '<span class="fs-msub-back-arrow" aria-hidden="true"><svg viewBox="0 0 14 10" width="14" height="10" fill="none"><path d="M5 1L1 5l4 4M1 5h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>' + label + '</span>';
      panel.appendChild(back);

      // Split the cloned content: Shop-By links → scroll zone, products → bottom.
      var shop = inner.querySelector('.fs-mega__shop');
      var best = inner.querySelector('.fs-mega__best');

      if (shop) {
        var linksZone = document.createElement('div');
        linksZone.className = 'fs-msub-links fs-macc__panel';
        linksZone.appendChild(shop.cloneNode(true));
        panel.appendChild(linksZone);
      }
      if (best) {
        var prodZone = document.createElement('div');
        prodZone.className = 'fs-msub-products fs-macc__panel';
        var bestClone = best.cloneNode(true);
        // Compact horizontal card: lift the add-to-cart form out of the info
        // column to a direct card child so it sits at the card's right edge.
        var cards = bestClone.querySelectorAll('.fs-bestseller-card');
        for (var c = 0; c < cards.length; c++) {
          var form = cards[c].querySelector('product-form-component, .fs-bestseller-card__form');
          if (form) cards[c].appendChild(form);
        }
        prodZone.appendChild(bestClone);
        panel.appendChild(prodZone);
      }
      host.appendChild(panel);

      (function (p, b) {
        b.addEventListener('click', function () { p.classList.remove('is-open'); });
        return p;
      })(panel, back);

      (function (t, p) {
        t.addEventListener('click', function () { p.classList.add('is-open'); });
      })(trigger, panel);
    }
  }

  function init() {
    var panels = document.querySelectorAll('[data-fs-mega]');
    if (!panels.length) return;
    for (var i = 0; i < panels.length; i++) bindPanel(panels[i]);

    buildMobileSubmenus(panels);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { for (var j = 0; j < closers.length; j++) closers[j](); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
